import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import MinDurationDrawer from 'components/drawer/MinDurationdrawer';
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ShowHideButton from "components/table/ShowHideButton";

const MinDurationTable = ({
    MindurationTabledata,
    hideEdit,

}) => {
    const { title, serviceId, handleModalOpen, handleUpdate, handleView } = useToggleDrawer();
    const durationdata = MindurationTabledata;

    return (
        <>
            <DeleteModal id={serviceId} title={title} />

            <MainDrawer>
                <MinDurationDrawer id={serviceId} />
            </MainDrawer>

            <TableBody>
                {durationdata?.map((data, index) => (
                    <TableRow key={data?.id}>

                        <TableCell className="text-sm text-center">
                            {index + 1}
                        </TableCell>

                        <TableCell className="text-sm text-center">
                            {data?.name}
                        </TableCell>

                        <TableCell className="max-w-sm break-words whitespace-normal leading-relaxed text-sm text-center">
                            {data?.min_booking_minutes}
                        </TableCell>

                        <TableCell className="text-sm text-center">
                            <ShowHideButton
                                id={data?.id}
                                status={data?.is_active}
                                Loading={true}
                            />
                        </TableCell>

                        <TableCell className="text-center">

                            <EditDeleteButton
                                title={"Min Duration"}
                                id={data.id}
                                handleUpdate={handleUpdate}
                                handleModalOpen={handleModalOpen}
                                hideEdit={hideEdit}
                            // hideDelete={hideDelete}
                            />
                        </TableCell>

                    </TableRow>
                ))}
            </TableBody>

        </>
    );
};

export default MinDurationTable;
